import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import EmployeeDetailPres from '../../presentational/EmployeeDetail/EmployeeDetailPres';
import { fetchEmployeeDetailHeaderApi } from 'src/services/employees.service';
import { PageTitle } from 'src/ui/library/PageTitle';
import { withSnackbar } from 'notistack';
import { upsertEmployeesContactEmploymentHistorySalaryApi } from 'src/services/employees.service';
import moment from 'moment';
import WarningIcon from '@material-ui/icons/Warning';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

class EmployeeDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'Information',
      header: {},
      isLoading: false,
      relatedTabs: [],
    };
  }

  componentDidMount() {
    const { employeeId } = this.props.match.params;

    this.setState({
      isLoading: true,
    });
    fetchEmployeeDetailHeaderApi(employeeId).then(
      results => {
        if (results && !results.error && !results.errors) {
          const header = {
            employeeName: results.employeeName,
            employeeId: results.employeeId,
          };
          this.setState({
            header,
          });
        } else {
          let errorMsg = ' - ';
          if (results.error) {
            errorMsg += results.error.message;
          } else if (results.errors) {
            results.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.enqueueSnackbar('Failed to fetch header' + errorMsg, { variant: 'error' });
        }
        this.setState({
          isLoading: false,
        });
      },
      error => {
        this.props.enqueueSnackbar('Failed to fetch header - ' + error.message, { variant: 'error' });
        this.setState({
          isLoading: false,
        });
      },
    );
  }

  tabsHandler = (event, value) => {
    this.setState({
      tab: value,
    });
  };

  getAdditionalPropsForRelatedEntities = relationshipName => {
    let fetch,
      get,
      upsert,
      del = null;
    let relatedEntities = [];
    let sortColumn = '';
    let readOnly = false;
    let onValidate = null;
    let displayName = '';
    let tabLabel = '';

    const dateErrorValidation = [
      'ey_contact_ey_address_ContactId',
      'ey_contact_ey_contactcitizenship_ContactId',
      'ey_contact_ey_contacteducation_ContactId',
      'ey_contact_ey_contactemploymenthistory_ContactId',
      'ey_contact_ey_contactidentificationnumber_ContactId',
      'ey_contact_ey_contacttravelhistory_ContactId',
      'ey_contact_ey_contactinsurance',
      'ey_relationship_OriginatingContactId_Cont',
      'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId',
    ];

    if (dateErrorValidation.includes(relationshipName)) {
      onValidate = (fields, setErrorFn) => {
        const {
          ey_startdate,
          ey_enddate,
          ey_effectivestartdate,
          ey_effectiveenddate,
          ey_travelstartdate,
          ey_travelenddate,
          ey_issuedate,
        } = fields;
        let error = false;

        if (
          ((ey_startdate || ey_issuedate) && ey_enddate) ||
          (ey_effectivestartdate && ey_effectiveenddate) ||
          (ey_travelstartdate && ey_travelenddate)
        ) {
          let s;
          let e;

          if (
            (ey_startdate && ey_startdate.length === 11) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 11) ||
            (ey_travelstartdate && ey_travelstartdate.length === 11) ||
            (ey_issuedate && ey_issuedate.length === 11)
          ) {
            s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'DD-MMM-YYYY').format('YYYYMMDD');
          }
          if (
            (ey_enddate && ey_enddate.length === 11) ||
            (ey_effectiveenddate && ey_effectiveenddate.length === 11) ||
            (ey_travelenddate && ey_travelenddate.length === 11)
          ) {
            e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'DD-MMM-YYYY').format('YYYYMMDD');
          }
          if (
            (ey_startdate && ey_startdate.length === 10) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 10) ||
            (ey_travelstartdate && ey_travelstartdate.length === 10) ||
            (ey_issuedate && ey_issuedate.length === 10)
          ) {
            s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'YYYY-MM-DD').format('YYYYMMDD');
          }
          if (
            (ey_enddate && ey_enddate.length === 10) ||
            (ey_effectiveenddate && ey_effectiveenddate.length === 10) ||
            (ey_travelenddate && ey_travelenddate.length === 10)
          ) {
            e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'YYYY-MM-DD').format('YYYYMMDD');
          }
          const setErrorDate =
            (ey_enddate && 'ey_enddate') || (ey_effectiveenddate && 'ey_effectiveenddate') || (ey_travelenddate && 'ey_travelenddate');
          if (moment(e).diff(moment(s), 'days') < 0) {
            const errorMsg = (
              <span className="error-msg">
                <WarningIcon />
                <b>End Date cannot be before Start Date.</b>
              </span>
            );
            setErrorFn(setErrorDate, true, errorMsg);
            error = true;
          }
        }
        return error;
      };
    }
    if (relationshipName === 'ey_contact_ey_contactemploymenthistory_ContactId') {
      relatedEntities = {
        parentEntitySetName: 'ey_contactemploymenthistories',
        parentEntityName: 'ey_contactemploymenthistory',
        relationships: ['ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId'],
      };
    } else if (relationshipName === 'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId') {
      upsert = upsertEmployeesContactEmploymentHistorySalaryApi;
      displayName = 'Employment Salary';
      tabLabel = 'Employment Salary';
    }

    return {
      fetch,
      get,
      upsert,
      del,
      relatedEntities,
      sortColumn,
      readOnly,
      displayName,
      onValidate,
      tabLabel,
    };
  };

  render() {
    return (
      <React.Fragment>
        <div className={fnShowNewDashboard() ? 'employee-detail-row-click' : null}>
          <PageTitle title={intl.get('employees.details.pageTitle')} />
          <EmployeeDetailPres
            handleTabSelect={this.tabsHandler}
            tab={this.state.tab}
            getAdditionalPropsForRelatedEntities={this.getAdditionalPropsForRelatedEntities}
            {...this.state}
            {...this.props}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    relatedTabs: state.employees.relatedTabs,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(EmployeeDetailContainer));
